import React from 'react';
import { Routes, Route } from "react-router-dom";

import './App.css';
import Login from './pages/Login';
import Curriculum from './pages/Curriculum';
import Scholarship from './pages/Scholarship';
import NotFound from './pages/NotFound';
import ChangePassword from './pages/ChangePassword';
import { AuthorizeUser } from './middleware/auth';

function App() {

  return (
    <div className="App">
      <Routes>
        <Route path={``} element={<Login />} />
        <Route path={`/login`} element={<Login />} />
        <Route path={`/curriculum/*`} element={<AuthorizeUser><Curriculum /></AuthorizeUser>}>
          <Route path=":courseID/:semesterID/*" element={<AuthorizeUser><Curriculum /></AuthorizeUser>}>
            <Route path="common_goal/:studentID/:commonProgressID/*" element={<AuthorizeUser><Curriculum /></AuthorizeUser>} />
            <Route path="individual_goal/:studentID/:individualProgressID/*" element={<AuthorizeUser><Curriculum /></AuthorizeUser>} />
          </Route>
        </Route>
        <Route path={`/scholarship/*`} element={
          <AuthorizeUser>
            <Scholarship />
          </AuthorizeUser>
        }>
          <Route path=":courseID/:semesterID/*" element={<AuthorizeUser><Scholarship /></AuthorizeUser>}>
            <Route path="individual_goal/:studentID/:progressID/*" element={<AuthorizeUser><Scholarship /></AuthorizeUser>} />
          </Route>
        </Route>
        <Route path={`/change_password`} element={<AuthorizeUser><ChangePassword /></AuthorizeUser>} />
        <Route path={`*`} element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
